import config from 'config';
import { Navigate, RouteObject } from 'react-router-dom';
import AuthorizedWrapper from 'src/components/authorizationWrapper';
import StatePreservingNavigate from 'src/routes/StatePreservingNavigate';
import SkillPlayRedirect from 'src/routes/SkillPlayRedirect';
import { MULTIPLAYER_USER_TYPES, UserRole } from 'src/constants';
import { lazyWithChunkReload } from 'src/helpers/chunkLoadError';

// import LearningProfile from 'src/pages/learningProfile';

const handleDynamicImportError = lazyWithChunkReload;

const PublicUserLayout = handleDynamicImportError(
  () => import('src/components/PublicUserLayout'),
);
const CandidateChat = handleDynamicImportError(
  () => import('src/pages/chat/CandidateChat'),
);
const EmployerChat = handleDynamicImportError(
  () => import('src/pages/chat/EmployerChat'),
);
const AdminChat = handleDynamicImportError(
  () => import('src/pages/chat/AdminChat'),
);
const JobDashboard = handleDynamicImportError(
  () => import('src/pages/postedJobList/JobDashboard'),
);
const JobPosted = handleDynamicImportError(() => import('src/pages/jobPosted'));
const Support = handleDynamicImportError(() => import('src/pages/userSupport'));
const FeatureRequest = handleDynamicImportError(
  () => import('src/pages/userSupport/FeatureRequest'),
);
const Feedback = handleDynamicImportError(
  () => import('src/pages/userSupport/Feedback'),
);
const MyReports = handleDynamicImportError(
  () => import('src/pages/userSupport/MyReports'),
);
const MyReportDetail = handleDynamicImportError(
  () => import('src/pages/userSupport/MyReportDetail'),
);
const ReportBug = handleDynamicImportError(
  () => import('src/pages/userSupport/ReportBug'),
);
const CompetitionListAdmin = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionListAdmin'),
);

const StatisticsAdmin = handleDynamicImportError(
  () => import('src/pages/statisticsAdmin'),
);
const BillingEmployer = handleDynamicImportError(
  () => import('src/pages/BillingEmployer'),
);
const BulkEmail = handleDynamicImportError(
  () => import('src/pages/bulkEmailAdmin'),
);
const ExperimentsAdmin = handleDynamicImportError(
  () => import('src/pages/experimentsAdmin'),
);
const AiModelsAdmin = handleDynamicImportError(
  () => import('src/pages/aiModelsAdmin'),
);
const WhatsappNotifiactionAdmin = handleDynamicImportError(
  () => import('src/pages/whatsappNotificationAdmin'),
);
const MobileAppNotificationAdmin = handleDynamicImportError(
  () => import('src/pages/mobileAppNotificationAdmin'),
);
const UserManagement = handleDynamicImportError(
  () => import('src/pages/userManagementAdmin'),
);
const MocktestAdmin = handleDynamicImportError(
  () => import('src/pages/mocktestAdmin'),
);
const MocktestForm = handleDynamicImportError(
  () => import('src/pages/mocktestAdmin/MocktestForm'),
);
const ReviewQuestionsAdmin = handleDynamicImportError(
  () => import('src/pages/reviewQuestionsAdmin'),
);
const UserLevelAdmin = handleDynamicImportError(
  () => import('src/pages/userLevelAdmin'),
);
const CreateEditUserLevel = handleDynamicImportError(
  () => import('src/pages/userLevelAdmin/CreateEditUserLevel'),
);
const DailyMissionAdmin = handleDynamicImportError(
  () => import('src/pages/dailyMissionAdmin'),
);
const CreateEditDailyMission = handleDynamicImportError(
  () => import('src/pages/dailyMissionAdmin/CreateEditDailyMission'),
);
const RewardPromotionAdmin = handleDynamicImportError(
  () => import('src/pages/rewardPromotionAdmin'),
);
const CreateEditRewardPromotion = handleDynamicImportError(
  () => import('src/pages/rewardPromotionAdmin/CreateEditRewardPromotion'),
);

const LevelAdmin = handleDynamicImportError(
  () => import('src/pages/levelAdmin'),
);
const CreateEditLevel = handleDynamicImportError(
  () => import('src/pages/levelAdmin/CreateEditLevel'),
);
const BadgeAdmin = handleDynamicImportError(
  () => import('src/pages/badgeAdmin'),
);
const CreateEditBadge = handleDynamicImportError(
  () => import('src/pages/badgeAdmin/CreateEditBadge'),
);
const CodingPracticeAdmin = handleDynamicImportError(
  () => import('src/pages/codingPracticeAdmin'),
);
const CodingPracticeCategoryAdmin = handleDynamicImportError(
  () => import('src/pages/codingPracticeAdmin/CategoryDetail'),
);
const DashboardBannerAdmin = handleDynamicImportError(
  () => import('src/pages/dashboardBannerAdmin'),
);
const CreateEditDashboardBanner = handleDynamicImportError(
  () => import('src/pages/dashboardBannerAdmin/CreateEditBanner'),
);
const BugsReportedAdmin = handleDynamicImportError(
  () => import('src/pages/bugsReportedAdmin'),
);
const StoreAdmin = handleDynamicImportError(
  () => import('src/pages/storeAdmin'),
);
const OrdersAdmin = handleDynamicImportError(
  () => import('src/pages/storeAdmin/OrdersAdmin'),
);
const ItemVariantsAdmin = handleDynamicImportError(
  () => import('src/pages/storeAdmin/ItemVariants'),
);

const StoreItemsByType = handleDynamicImportError(
  () => import('src/pages/storeAdmin/ItemsByType'),
);
const PotentialRecruiterPage = handleDynamicImportError(
  () =>
    import('src/pages/potentialRecruiterAdmin/pages/PotentialRecruiterPage'),
);
const DataManagment = handleDynamicImportError(
  () => import('src/pages/dataManagementAdmin'),
);
const Specialization = handleDynamicImportError(
  () => import('src/pages/dataManagementAdmin/pages/Specialization'),
);
const CampusAmbassadorHQ = handleDynamicImportError(
  () => import('src/pages/campusAmbassador'),
);
const CampusAmbassadorAdmin = handleDynamicImportError(
  () => import('src/pages/campusAmbassadorAdmin'),
);
const CampusAmbassadorCohortDetail = handleDynamicImportError(
  () => import('src/pages/campusAmbassadorAdmin/CohortDetail'),
);
const CampusAmbassadorLeaderboard = handleDynamicImportError(
  () => import('src/pages/campusAmbassadorAdmin/CohortLeaderboard'),
);
const CreateCACohort = handleDynamicImportError(
  () => import('src/pages/campusAmbassadorAdmin/CreateCohort'),
);
const PotentialApplicants = handleDynamicImportError(
  () => import('src/pages/potentialApplicantsAdmin'),
);
const Subscriptions = handleDynamicImportError(
  () => import('src/pages/subscriptionsAdmin'),
);
const CouponAdmin = handleDynamicImportError(
  () => import('src/pages/couponsAdmin'),
);
const CreateEditCoupon = handleDynamicImportError(
  () => import('src/pages/couponsAdmin/CreateEditCoupon'),
);
const CreateEditCompetition = handleDynamicImportError(
  () => import('src/pages/userMadeCompetition/pages/CreateEditCompetition'),
);
const ChatLogs = handleDynamicImportError(
  () => import('src/pages/chatLogsAdmin'),
);
const ReferralSummary = handleDynamicImportError(
  () => import('src/pages/referralSummaryAdmin'),
);
const ReferralMilestonesAdmin = handleDynamicImportError(
  () => import('src/pages/referralMilestonesAdmin'),
);

const FacultyJoin = handleDynamicImportError(
  () => import('src/pages/facultyJoin'),
);
const FacultyAdmin = handleDynamicImportError(
  () => import('src/pages/facultyAdmin'),
);
const MultiplayerPersonasAdmin = handleDynamicImportError(
  () => import('src/pages/multiplayerPersonasAdmin'),
);
const SkillRelevanceAdmin = handleDynamicImportError(
  () => import('src/pages/skillRelevanceAdmin'),
);
const SkillStatistics = handleDynamicImportError(
  () => import('src/pages/skillStatisticsAdmin'),
);
const ActivityAdmin = handleDynamicImportError(
  () => import('src/pages/activityAdmin'),
);
const AuditLogAdmin = handleDynamicImportError(
  () => import('src/pages/auditLogAdmin'),
);
const GemsActivity = handleDynamicImportError(
  () => import('src/pages/gemsActivity'),
);
const MatchingProfiles = handleDynamicImportError(
  () => import('src/pages/reviewJob/components/MatchingProfiles'),
);
const SkillManagementAdmin = handleDynamicImportError(
  () => import('src/pages/skillManagementAdmin'),
);
const CoursesAdmin = handleDynamicImportError(
  () => import('src/pages/coursesAdmin'),
);
const CourseFeedbackAdmin = handleDynamicImportError(
  () => import('src/pages/coursesAdmin/CourseFeedback'),
);
const SkillContentFormAdmin = handleDynamicImportError(
  () => import('src/pages/skillContentAdmin'),
);
const CompetitionContentAdmin = handleDynamicImportError(
  () => import('src/pages/competitionContentAdmin'),
);
const SkillTodosAdmin = handleDynamicImportError(
  () => import('src/pages/skillTodosAdmin'),
);
const SkillSeriesAdmin = handleDynamicImportError(
  () => import('src/pages/skillSeriesAdmin'),
);
const ExtensionRemoved = handleDynamicImportError(
  () => import('src/pages/extensionRemoved'),
);
const ExtensionSignIn = handleDynamicImportError(
  () => import('src/pages/extensionSignIn'),
);
const Unsubscribe = handleDynamicImportError(
  () => import('src/pages/unsubscribeEmailList'),
);
const ReviewOrg = handleDynamicImportError(() => import('src/pages/reviewOrg'));
const OutreachAdmin = handleDynamicImportError(
  () => import('src/pages/outreachAdmin'),
);
const GlobalVarsAdmin = handleDynamicImportError(
  () => import('src/pages/globalVarsAdmin'),
);
const EmailTemplatesAdmin = handleDynamicImportError(
  () => import('src/pages/emailTemplatesAdmin'),
);
const EmailTypeDetail = handleDynamicImportError(
  () => import('src/pages/emailTemplatesAdmin/EmailTypeDetail'),
);
const CreditPricingAdmin = handleDynamicImportError(
  () => import('src/pages/creditPricingAdmin'),
);
const CareerGuidanceAdmin = handleDynamicImportError(
  () => import('src/pages/careerGuidanceAdmin'),
);
const InterviewRecordingsAdmin = handleDynamicImportError(
  () => import('src/pages/interviewRecordingsAdmin'),
);
const AppVersionAdmin = handleDynamicImportError(
  () => import('src/pages/appVersionAdmin'),
);
const AdminToken = handleDynamicImportError(
  () => import('src/pages/adminToken'),
);
const ReviewJob = handleDynamicImportError(() => import('src/pages/reviewJob'));
const BackgroundVerificationsAdmin = handleDynamicImportError(
  () => import('src/pages/backgroundVerificationsAdmin'),
);
const ManagedHiringAdmin = handleDynamicImportError(
  () => import('src/pages/managedHiringAdmin'),
);
const JobEmailSettings = handleDynamicImportError(
  () => import('src/pages/jobEmailSettings'),
);

const ExternalJobsAdmin = handleDynamicImportError(
  () => import('src/pages/externalJobsAdmin'),
);
const TurbohireIntel = handleDynamicImportError(
  () => import('src/pages/turbohireIntel'),
);
const ChromeExtensionAdmin = handleDynamicImportError(
  () => import('src/pages/statisticsAdmin/chromeExtension'),
);
const AskAbekusAdmin = handleDynamicImportError(
  () => import('src/pages/statisticsAdmin/askAbekus'),
);
const CourseStatsAdmin = handleDynamicImportError(
  () => import('src/pages/statisticsAdmin/courses'),
);
const ReviewStatsAdmin = handleDynamicImportError(
  () => import('src/pages/statisticsAdmin/reviews'),
);
const StatisticsLayout = handleDynamicImportError(
  () => import('src/pages/statisticsAdmin/layout'),
);
const ManagedHiringRequestDetail = handleDynamicImportError(
  () => import('src/pages/managedHiringAdmin/ManagedHiringRequestDetail'),
);

const CompetitionList = handleDynamicImportError(
  () => import('src/pages/competition'),
);

const CompetitionDetails = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionDetails'),
);

const JobChallengeDetails = handleDynamicImportError(
  () => import('src/pages/competition/JobChallengeDetails'),
);

const CompetitionPlay = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionPlay'),
);

const CompetitionSubmission = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionSubmission'),
);
const CompetitionGallery = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionGallery'),
);
const CompetitionSinglePost = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionSinglePost'),
);
const CompetitionScoreAdmin = handleDynamicImportError(
  () => import('src/pages/competition/CompetitionScoreAdmin'),
);

const EmployerLayout = handleDynamicImportError(
  () => import('src/components/employerLayout'),
);
const SharedLayout = handleDynamicImportError(
  () => import('src/components/SharedLayout'),
);
const AdminHomeRedirect = handleDynamicImportError(
  () => import('src/components/adminLayout/AdminHomeRedirect'),
);
const AdminLayout = handleDynamicImportError(
  () => import('src/components/adminLayout'),
);
const AdminDashboard = handleDynamicImportError(
  () => import('src/pages/adminDashboard'),
);

const PostingPreview = handleDynamicImportError(
  () => import('src/pages/postedJobList/PostingPreview'),
);

const CandidateLayout = handleDynamicImportError(
  () => import('src/components/candidateLayout'),
);
const FindJobsPage = handleDynamicImportError(
  () => import('src/pages/findJobs'),
);

const ViewQuestionDetails = handleDynamicImportError(
  () => import('src/pages/contribute/ViewQuestionDetails'),
);

const ApplyJob = handleDynamicImportError(
  () => import('src/pages/findJobs/applyJob'),
);
const DetailedJob = handleDynamicImportError(
  () => import('src/pages/findJobs/detailedJob'),
);
const AppliedJobsPage = handleDynamicImportError(
  () => import('src/pages/appliedJobs'),
);
const EditProfilePage = handleDynamicImportError(
  () => import('src/pages/xRay/EditProfile'),
);
const BulkResumePage = handleDynamicImportError(
  () => import('src/pages/xRay/BulkJobDetails'),
);

const XRayJobList = handleDynamicImportError(() => import('src/pages/xRay'));
const ReviewJobDescriptionPage = handleDynamicImportError(
  () => import('src/pages/xRay/ReviewDescription'),
);
const UploadFilePage = handleDynamicImportError(
  () => import('src/pages/xRay/UploadResume'),
);
const DetailedAppliedJob = handleDynamicImportError(
  () => import('src/pages/appliedJobs/detailedJob'),
);
const AssessmentPage = handleDynamicImportError(
  () => import('src/pages/appliedJobs/assessment'),
);

const EmployerTeamManagement = handleDynamicImportError(
  () => import('src/pages/employerTeamManagement'),
);
const TalentPipeline = handleDynamicImportError(
  () => import('src/pages/talentPipeline'),
);

const InterviewsDashboard = handleDynamicImportError(
  () => import('src/pages/interviews'),
);

const MeetingRoom = handleDynamicImportError(
  () => import('src/pages/interview/MeetingRoom'),
);

const CandidateInterviews = handleDynamicImportError(
  () => import('src/pages/interviews/CandidateInterviews'),
);

const OrgDetails = handleDynamicImportError(
  () => import('src/pages/allOrgs/OrgDetails'),
);

const Layout = handleDynamicImportError(() => import('../components/layout'));
const JobList = handleDynamicImportError(
  () => import('../pages/postedJobList'),
);
const JobDetails = handleDynamicImportError(
  () => import('../pages/jobDetails'),
);
const JobPost = handleDynamicImportError(() => import('../pages/jobPosting'));
const JobAIDraftEntry = handleDynamicImportError(
  () => import('src/pages/jobAIDraft'),
);
const JobAIDraft = handleDynamicImportError(
  () => import('src/pages/jobAIDraft/draft'),
);
const CandidateProfile = handleDynamicImportError(
  () => import('../pages/candidateProfile'),
);
const MyBadges = handleDynamicImportError(() => import('../pages/myBadges'));
const Authentication = handleDynamicImportError(
  () => import('../pages/authentication'),
);
const HomeRedirect = handleDynamicImportError(() => import('../pages/home'));
const SignUp = handleDynamicImportError(
  () => import('../pages/authentication/components/signup'),
);
const Login = handleDynamicImportError(
  () => import('../pages/authentication/components/login'),
);
const ForgotPassword = handleDynamicImportError(
  () => import('../pages/authentication/components/forgotPass'),
);

const CandidateOnboarding = handleDynamicImportError(
  () => import('../pages/candidateOnboarding'),
);
const EmployerOnboarding = handleDynamicImportError(
  () => import('../pages/employerOnboarding'),
);
const PlacementPartnerOnboarding = handleDynamicImportError(
  () => import('../pages/placementPartnerOnboarding'),
);
const PlacementPartnerLayout = handleDynamicImportError(
  () => import('../pages/placementPartner/PlacementPartnerLayout'),
);
const PartnerDashboard = handleDynamicImportError(
  () => import('../pages/placementPartner/Dashboard'),
);
const PartnerGroupDetail = handleDynamicImportError(
  () => import('../pages/placementPartner/GroupDetail'),
);
const FacultyLayout = handleDynamicImportError(
  () => import('../components/facultyLayout'),
);
const FacultyDashboard = handleDynamicImportError(
  () => import('../pages/facultyDashboard'),
);
const FacultyQuizzes = handleDynamicImportError(
  () => import('../pages/facultyQuizzes'),
);
const FacultyClass = handleDynamicImportError(
  () => import('../pages/facultyClass'),
);
const FacultyStudentInsights = handleDynamicImportError(
  () => import('../pages/facultyStudentInsights'),
);
const StudentLayout = handleDynamicImportError(
  () => import('../components/studentLayout'),
);
const StudentClasses = handleDynamicImportError(
  () => import('../pages/studentClasses'),
);
const StudentClass = handleDynamicImportError(
  () => import('../pages/studentClass'),
);
const StudentTodo = handleDynamicImportError(
  () => import('../pages/studentTodo'),
);
const StudentCourses = handleDynamicImportError(
  () => import('../pages/studentCourses'),
);
const StudentCourse = handleDynamicImportError(
  () => import('../pages/studentCourses/Course'),
);
const StudentLesson = handleDynamicImportError(
  () => import('../pages/studentCourses/Lesson'),
);
const QuizMarks = handleDynamicImportError(() => import('../pages/quizMarks'));
const QuizAttempt = handleDynamicImportError(
  () => import('../pages/quizAttempt'),
);
const FacultyQuizBuilder = handleDynamicImportError(
  () => import('../pages/quizBuilder'),
);
const FacultyExam = handleDynamicImportError(
  () => import('../pages/facultyExam'),
);
const FacultyReview = handleDynamicImportError(
  () => import('../pages/facultyReview'),
);
const FacultyReviewSubmissions = handleDynamicImportError(
  () => import('../pages/facultyReview/Submissions'),
);
const FacultyReviewAttempt = handleDynamicImportError(
  () => import('../pages/facultyReview/AttemptReview'),
);
const FacultyReviewQuestions = handleDynamicImportError(
  () => import('../pages/facultyReview/QuestionReview'),
);
const FacultyLibrary = handleDynamicImportError(
  () => import('../pages/facultyLibrary'),
);
const FacultyLibraryFolder = handleDynamicImportError(
  () => import('../pages/facultyLibrary/Folder'),
);
const FacultyCourses = handleDynamicImportError(
  () => import('../pages/facultyCourses'),
);
const FacultyCourseBuilder = handleDynamicImportError(
  () => import('../pages/facultyCourseBuilder'),
);
const ClaimInvite = handleDynamicImportError(
  () => import('../pages/claimInvite'),
);
const CandidateSettings = handleDynamicImportError(
  () => import('../pages/settings'),
);
const EmployerProfile = handleDynamicImportError(
  () => import('../pages/employerProfile'),
);
const Transactions = handleDynamicImportError(
  () => import('../pages/userTransactions'),
);
const Contribute = handleDynamicImportError(
  () => import('../pages/contribute'),
);
const CreateQuestion = handleDynamicImportError(
  () => import('../pages/contribute/CreateQuestion'),
);
const QuestionHistory = handleDynamicImportError(
  () => import('../pages/questionHistory'),
);

const InviteApplicants = handleDynamicImportError(
  () => import('../pages/inviteApplicants'),
);

const SkillReport = handleDynamicImportError(
  () => import('../pages/skillBuilder/report'),
);

const SkillHub = handleDynamicImportError(
  () => import('../pages/skillBuilder/home'),
);

const SkillDashboard = handleDynamicImportError(
  () => import('../pages/skillBuilder/dashboard'),
);

const SkillBuilderMultiPlay = handleDynamicImportError(
  () => import('../pages/skillBuilder/SkillBuilderMultiPlay'),
);

const MultiplayerPractice = handleDynamicImportError(
  () => import('../pages/skillBuilder'),
);

const MultiplayerRoomRoute = handleDynamicImportError(
  () => import('../pages/skillBuilder/MultiplayerRoomRoute'),
);

const CodingPractice = handleDynamicImportError(
  () => import('../pages/codingPractice'),
);

const CodingProblem = handleDynamicImportError(
  () => import('../pages/codingPractice/problem'),
);

const CodingCategoryZone = handleDynamicImportError(
  () => import('../pages/codingPractice/category'),
);

const SkillTest = handleDynamicImportError(() => import('../pages/skillTest'));
const SkillTestPlay = handleDynamicImportError(
  () => import('../pages/skillTest/SkillTestPlay'),
);
const SkillTestResult = handleDynamicImportError(
  () => import('../pages/skillTest/SkillTestResult'),
);

const Landing = handleDynamicImportError(
  () => import('../pages/loginLandingScreen'),
);

const ResumeBuilderHomePage = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder'),
);

const ResumeBuilderContainer = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/CreateEditResume'),
);

const TemplatesPage = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/pages/templates'),
);
const AnswersByCandidates = handleDynamicImportError(
  () => import('src/pages/userMadeCompetition/pages/AnswersByCandidates'),
);
const ViewCandidates = handleDynamicImportError(
  () => import('src/pages/userMadeCompetition/pages/ViewCandidates'),
);

const AutofillPage = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/pages/autofill'),
);

const CoverLetterPrintPage = handleDynamicImportError(
  () => import('src/pages/coverLetterPrint'),
);
const JobFitResumePreviewPage = handleDynamicImportError(
  () =>
    import('src/pages/findJobs/components/authenticatedJobDetails/jobFitResume/JobFitResumePreviewPage'),
);

const TemplateShotPage = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/pages/templateShot'),
);
const JobFitAppPreviewPage = handleDynamicImportError(
  () => import('src/pages/findJobs/JobFitAppPreviewPage'),
);

const ResumeAdminLayout = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/pages/admin/layout'),
);

const ResumeAdminHomepage = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/pages/admin'),
);

const CreateResumeTemplatePage = handleDynamicImportError(
  () => import('src/pages/ResumeBuilder/pages/admin/createResumeTemplate'),
);

const StoreHome = handleDynamicImportError(
  () => import('src/pages/Store/Home'),
);

// Mobile-app only: the website checks out in the purchase dialog and links
// nowhere here. Kept as a route so the app can hand a cart its stores cannot
// bill over to the browser. See the note in src/pages/Store/Checkout.tsx.
const StoreCheckout = handleDynamicImportError(
  () => import('src/pages/Store/Checkout'),
);

const SpotlightSuccess = handleDynamicImportError(
  () => import('src/pages/Store/SpotlightSuccess'),
);

const PremiumSuccess = handleDynamicImportError(
  () => import('src/pages/Store/PremiumSuccess'),
);

const OrdersHistory = handleDynamicImportError(
  () => import('src/pages/Store/OrdersHistory'),
);

const LeaderboardPage = handleDynamicImportError(
  () => import('src/pages/leaderboard'),
);

const SkillSelectorMobilePage = handleDynamicImportError(
  () => import('src/pages/leaderboard/SkillSelectorMobilePage'),
);

const CertificatePage = handleDynamicImportError(
  () => import('src/pages/certificate'),
);

const CompanyJobsPage = handleDynamicImportError(
  () => import('src/pages/companyJobs'),
);

const UserReferral = handleDynamicImportError(
  () => import('src/pages/userReferrals'),
);

const RewardsPage = handleDynamicImportError(() => import('src/pages/rewards'));

const NotFound = handleDynamicImportError(() => import('src/pages/notFound'));

const ApplicantDashboard = handleDynamicImportError(
  () => import('src/pages/applicantDashboard'),
);
const CareerGuidancePage = handleDynamicImportError(
  () => import('src/pages/careerGuidance'),
);
const Questions = handleDynamicImportError(
  () => import('src/pages/skillManagementAdmin/components/Questions'),
);

const EvaluationAssessmentCreate = handleDynamicImportError(
  () => import('src/pages/evaluationAssessment'),
);
const JobChallengeQuestions = handleDynamicImportError(
  () => import('src/pages/reviewJob/JobChallengeQuestions'),
);

const GuidedCourseHomePage = handleDynamicImportError(
  () => import('src/pages/course'),
);

const GuidedCourseDetailPage = handleDynamicImportError(
  () => import('src/pages/course/detail'),
);

const CourseForgePage = handleDynamicImportError(
  () => import('src/pages/course/forge'),
);

const GuidedCoursePathPage = handleDynamicImportError(
  () => import('src/pages/course/path'),
);

const GuidedCourseReadingPage = handleDynamicImportError(
  () => import('src/pages/course/reading'),
);

const GuidedCourseIntroPage = handleDynamicImportError(
  () => import('src/pages/course/intro'),
);

const GuidedCoursePlayPage = handleDynamicImportError(
  () => import('src/pages/course/play'),
);

const GuidedCourseTestPage = handleDynamicImportError(
  () => import('src/pages/course/test'),
);

const getRoutes = (isAuthenticated: boolean): RouteObject[] => [
  {
    path: '/login',
    children: [
      {
        element: (
          <Authentication>
            <Login />
          </Authentication>
        ),
        index: true,
      },
    ],
  },
  {
    path: '/signup',
    children: [
      {
        element: (
          <Authentication>
            <SignUp />
          </Authentication>
        ),
        index: true,
      },
    ],
  },
  {
    path: '/home',
    element: <HomeRedirect />,
  },
  {
    path: '/*',
    element: <Navigate to={'/404'} replace />,
  },
  {
    path: '/',
    element: (
      <Navigate
        to={['development', 'dev'].includes(config.ENV) ? '/signup' : '/'}
        replace
      />
    ),
  },
  {
    path: '/forgot-password',
    children: [
      {
        element: (
          <Authentication>
            <ForgotPassword />
          </Authentication>
        ),
        index: true,
      },
    ],
  },
  {
    path: '/onboarding',
    element: <Layout />,
    children: [
      {
        element: <Landing />,
        index: true,
      },
    ],
  },
  {
    path: '/employer-post',
    element: <Layout />,
    children: [
      {
        element: <EmployerOnboarding />,
        index: true,
      },
    ],
  },
  {
    path: '/candidate-post',
    element: <Layout />,
    children: [
      {
        element: <CandidateOnboarding />,
        index: true,
      },
    ],
  },
  {
    path: '/placement-partner-post',
    element: <Layout />,
    children: [
      {
        element: (
          <AuthorizedWrapper
            userTypes={[
              UserRole.Admin,
              UserRole.Applicant,
              UserRole.PlacementPartner,
            ]}
          >
            <PlacementPartnerOnboarding />
          </AuthorizedWrapper>
        ),
        index: true,
      },
    ],
  },
  {
    path: '/placement-partner',
    element: (
      <AuthorizedWrapper
        userTypes={[UserRole.Admin, UserRole.PlacementPartner]}
      >
        <PlacementPartnerLayout />
      </AuthorizedWrapper>
    ),
    children: [
      { element: <PartnerDashboard />, index: true },
      { element: <PartnerGroupDetail />, path: 'groups/:groupId' },
    ],
  },
  {
    // Faculty onboarding: public, outside the signed-in faculty app.
    path: '/faculty/join',
    element: <FacultyJoin />,
  },
  {
    path: '/faculty',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Faculty]}>
        <FacultyLayout />
      </AuthorizedWrapper>
    ),
    children: [
      { element: <FacultyDashboard />, index: true },
      { element: <FacultyClass />, path: 'classes/:classId' },
      { element: <FacultyExam />, path: 'classes/:classId/exams/:quizId' },
      {
        element: <FacultyStudentInsights />,
        path: 'classes/:classId/students/:memberId',
      },
      { element: <FacultyQuizzes />, path: 'quizzes' },
      { element: <FacultyQuizBuilder />, path: 'quizzes/:quizId' },
      { element: <FacultyReview />, path: 'review' },
      { element: <FacultyReviewSubmissions />, path: 'review/:quizId' },
      // Ranked above :attemptId, being static.
      {
        element: <FacultyReviewQuestions />,
        path: 'review/:quizId/questions',
      },
      {
        element: <FacultyReviewAttempt />,
        path: 'review/:quizId/:attemptId',
      },
      { element: <FacultyLibrary />, path: 'library' },
      { element: <FacultyLibraryFolder />, path: 'library/folders/:folderId' },
      { element: <FacultyCourses />, path: 'courses' },
      // `new` too: the builder starts before the course has a name.
      { element: <FacultyCourseBuilder />, path: 'courses/:courseId' },
      { element: <CandidateSettings />, path: 'settings' },
    ],
  },
  {
    path: '/claim/:token',
    element: <ClaimInvite />,
  },
  {
    path: '/jobs',
    element: <EmployerLayout />,
    children: [
      {
        element: <JobList />,
        index: true,
      },
      {
        element: <PostingPreview />,
        path: 'posting-preview/:jobAlias',
      },
      {
        element: <JobDashboard />,
        path: ':jobAlias/dashboard',
      },
      {
        element: (
          <AuthorizedWrapper userTypes={[UserRole.Admin, UserRole.Employer]}>
            <InviteApplicants />
          </AuthorizedWrapper>
        ),
        path: ':jobAlias/invite-applicants/:profileId?',
      },
    ],
  },
  {
    path: '/job-posted',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Admin, UserRole.Employer]}>
        <JobPosted />
      </AuthorizedWrapper>
    ),
  },
  {
    path: '/applicant-review',
    element: <EmployerLayout />,
    children: [
      {
        element: <JobDetails />,
        path: ':jobAlias',
      },
      {
        element: <JobDetails />,
        path: ':jobAlias/:username',
      },
      {
        element: <PostingPreview />,
        path: 'posting-preview/:jobAlias',
      },
    ],
  },
  {
    path: '/employer-profile',
    element: <EmployerLayout />,
    children: [
      {
        element: <EmployerProfile />,
        index: true,
      },
    ],
  },
  {
    path: '/billing-and-plans',
    element: <EmployerLayout />,
    children: [
      {
        element: <BillingEmployer />,
        index: true,
      },
    ],
  },
  {
    path: '/team-management',
    element: <EmployerLayout />,
    children: [
      {
        element: <EmployerTeamManagement />,
        index: true,
      },
    ],
  },
  {
    path: '/unlocked-candidates',
    element: <EmployerLayout />,
    children: [
      {
        element: <TalentPipeline />,
        index: true,
      },
    ],
  },
  {
    path: '/interviews',
    element: <EmployerLayout />,
    children: [
      {
        element: <InterviewsDashboard />,
        index: true,
      },
    ],
  },
  {
    path: '/interview/:interviewId/join',
    element: (
      <AuthorizedWrapper
        userTypes={[UserRole.Employer, UserRole.Admin, UserRole.Applicant]}
      >
        <MeetingRoom />
      </AuthorizedWrapper>
    ),
  },
  {
    path: '/chat/employer',
    element: <EmployerLayout />,
    children: [
      {
        element: <EmployerChat />,
        index: true,
        path: ':jobAlias?/:applicantUsername?',
      },
    ],
  },
  {
    path: '/chat/candidate',
    element: <CandidateLayout />,
    children: [{ element: <CandidateChat />, index: true }],
  },
  {
    // Plans are removed under the credits model — send any lingering links to jobs.
    path: '/employer-premium/*',
    element: <Navigate to="/jobs" replace />,
  },
  {
    path: '/competition',
    element: <CandidateLayout />,
    children: [
      { element: <CompetitionList />, index: true },
      { element: <CompetitionDetails />, path: ':competitionAlias' },
      {
        element: <JobChallengeDetails />,
        path: ':competitionAlias/job/:jobAlias',
      },
      { element: <CompetitionPlay />, path: ':competitionAlias/play' },
      {
        element: <CompetitionSubmission />,
        path: ':competitionAlias/submission',
      },
      {
        element: <CompetitionGallery />,
        path: ':competitionAlias/gallery',
      },
      {
        element: <CompetitionSinglePost />,
        path: ':competitionAlias/gallery/:submissionId',
      },
    ],
  },
  {
    path: '/company-jobs/:companyAlias',
    element: <CandidateLayout />,
    children: [{ element: <CompanyJobsPage />, index: true }],
  },
  {
    path: '/my-interviews',
    element: <CandidateLayout />,
    children: [{ element: <CandidateInterviews />, index: true }],
  },
  {
    path: '/certificate',
    element: <SharedLayout />,
    children: [
      {
        element: <CertificatePage />,
        path: ':certificateAlias',
      },
    ],
  },
  {
    path: '/orgs/:orgAlias',
    element: <EmployerLayout />,
    children: [{ element: <OrgDetails />, index: true }],
  },
  {
    path: '/job/post',
    element: <EmployerLayout />,
    children: [
      {
        element: <JobPost />,
        index: true,
      },
      {
        // Editing an existing posting. The id is in the URL so the page can be
        // refreshed or shared — it used to be carried only in router state, so
        // a reload silently dropped the employer into a blank new posting.
        // Duplicating stays on the bare path: it creates a *new* job, so the
        // source id has no business in the URL.
        element: <JobPost />,
        path: ':jobId',
      },
    ],
  },
  {
    path: '/jobs/new',
    element: <EmployerLayout />,
    children: [
      { element: <JobAIDraftEntry />, index: true },
      { element: <JobAIDraft />, path: 'draft' },
    ],
  },
  {
    path: '/job-search',
    element: <CandidateLayout />,
    children: [
      { element: <FindJobsPage />, index: true },
      {
        element: <DetailedJob />,
        path: ':jobAlias',
      },
      {
        element: <ApplyJob />,
        path: ':jobAlias/apply',
      },
    ],
  },
  // DEPRECATED-REMOVE added=2026-07-25 remove_after=2026-09-25 gate="Contribute retired — de-linked from nav (#1192), ~0 traffic, no remaining in-app entry points"
  // Question Contribute feature — removed from the sidebar (#1192). Kept live for
  // now; remove once the gate holds.
  {
    path: '/contribute',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      { element: <Contribute />, index: true },
      {
        path: 'create',
        element: <CreateQuestion />,
      },
      {
        path: ':questionId',
        element: <ViewQuestionDetails />,
      },
      {
        path: ':questionId/edit',
        element: <CreateQuestion />,
      },
    ],
  },
  {
    path: '/questionsList',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={'/contribute'} replace />,
      },
    ],
  },

  // DEPRECATED-REMOVE added=2026-07-25 remove_after=2026-09-25 gate="History retired — de-linked from nav (#1192), ~0 traffic"
  // Practice History page — removed from the sidebar (#1192). Kept live for now;
  // remove once the gate holds.
  {
    path: '/history',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Admin, UserRole.Applicant]}>
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <QuestionHistory />,
        index: true,
      },
    ],
  },
  {
    path: '/applied-jobs',
    element: <CandidateLayout />,
    children: [
      {
        element: <AppliedJobsPage />,
        index: true,
      },
      {
        element: <DetailedAppliedJob />,
        path: ':jobAlias',
      },
      {
        element: <AssessmentPage />,
        path: ':jobAlias/assessment',
      },
    ],
  },
  {
    path: '/profile',
    element: isAuthenticated ? <SharedLayout /> : <PublicUserLayout />,
    children: isAuthenticated
      ? [
          { element: <CandidateProfile />, index: true },
          { element: <CandidateProfile />, path: ':username' },
        ]
      : [{ element: <CandidateProfile />, path: ':username', index: true }],
  },
  {
    path: '/my-badges',
    element: <SharedLayout />,
    children: [{ element: <MyBadges />, index: true }],
  },
  {
    path: '/settings',
    element: <CandidateLayout />,
    children: [{ element: <CandidateSettings />, index: true }],
  },
  {
    path: '/employer/settings',
    element: <EmployerLayout />,
    children: [{ element: <CandidateSettings />, index: true }],
  },
  {
    path: '/x-ray',
    element: (
      <AuthorizedWrapper isAdmin>
        <EmployerLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <XRayJobList />,
        index: true,
      },

      {
        element: <BulkResumePage />,
        path: ':jobAlias',
      },
      {
        element: <BulkResumePage />,
        path: ':jobAlias/:applicantId',
      },
      {
        element: <ReviewJobDescriptionPage />,
        path: 'reviewDescription',
      },
      {
        element: <EditProfilePage />,
        path: 'editProfile',
      },
      {
        element: <UploadFilePage />,
        path: ':jobAlias/upload-resume',
      },
    ],
  },
  {
    path: '/transactions',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Admin, UserRole.Applicant]}>
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <Transactions />,
        index: true,
      },
    ],
  },
  // Resume Builder
  {
    path: '/resume-builder',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <CandidateLayout />
      </AuthorizedWrapper>
    ),
    children: [
      { element: <ResumeBuilderHomePage />, index: true },
      { element: <ResumeBuilderContainer />, path: 'new' },
      { element: <TemplatesPage />, path: 'templates' },
      { element: <AutofillPage />, path: 'autofill' },
      // Chrome-less full-size render of a job-tailored resume. The backend's
      // headless browser loads this to produce the PDF, so it must stay outside
      // CandidateLayout -- the sidebar and top bar would land in the export.
    ],
  },
  // Chrome-less cover letter, printed to PDF by the backend's headless
  // browser (POST /cover-letter/<id>/pdf) -- outside CandidateLayout so the
  // sidebar and top bar stay out of the file.
  {
    path: '/cover-letter/print',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <CoverLetterPrintPage />
      </AuthorizedWrapper>
    ),
  },
  {
    path: '/resume-builder/job-fit-preview',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <JobFitResumePreviewPage />
      </AuthorizedWrapper>
    ),
  },
  // Just the tailored resume sheet, for the mobile app to embed in a WebView.
  // Outside CandidateLayout on purpose: everything around the sheet — toggle,
  // template picker, price, download — is native on that side.
  // Chrome-less render of one template against placeholder data. The
  // backend's headless browser screenshots this to build the gallery
  // thumbnails, so it must stay outside CandidateLayout and needs no auth --
  // it shows sample data only.
  {
    path: '/resume-builder/template-shot',
    element: <TemplateShotPage />,
  },
  {
    path: '/resume-builder/job-fit-app-preview',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <JobFitAppPreviewPage />
      </AuthorizedWrapper>
    ),
  },
  {
    path: '/rewards',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <RewardsPage />,
        index: true,
      },
    ],
  },
  {
    path: '/user/referral',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <UserReferral />,
        index: true,
      },
    ],
  },
  {
    path: '/campus-ambassador',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Applicant, UserRole.Admin]}>
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      // The public marketing page lives on the landing app at /campus-ambassador
      // (nginx exact-match → Next.js). The HQ moved to /hq to free that path.
      { element: <Navigate to="hq" replace />, index: true },
      { path: 'hq', element: <CampusAmbassadorHQ /> },
      // /apply is retired — HQ handles apply/invite/accept. Redirect old links.
      {
        path: 'apply',
        element: <Navigate to="/campus-ambassador/hq" replace />,
      },
      // /accept is retired — HQ handles acceptance in-app (token from the stats
      // API, not the URL). Redirect old emailed links to HQ.
      {
        path: 'accept',
        element: <Navigate to="/campus-ambassador/hq" replace />,
      },
    ],
  },
  {
    path: '/mail/unsubscribe',
    element: <Unsubscribe />,
  },
  // Opened by Chrome when the autofill extension is removed. Public.
  {
    path: '/extension/removed',
    element: <ExtensionRemoved />,
  },
  // The Chrome extension's links: signs this browser in, then opens the page.
  {
    path: '/extension/signin',
    element: <ExtensionSignIn />,
  },
  {
    path: '/skill-builder',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      { element: <SkillHub />, index: true },
      { element: <SkillPlayRedirect />, path: ':skillId/play' },
      { element: <SkillReport />, path: ':skillId/report' },
      // UUID-only: a skill id resolves the dashboard. Guided courses have their
      // own surface at /course/:alias, so this no longer doubles as the public
      // course-details route. The static `multiplayer` sibling outranks this
      // dynamic segment, so it still resolves.
      { element: <SkillDashboard />, path: ':skillId' },
    ],
  },
  {
    path: '/course',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <GuidedCourseHomePage />,
        index: true,
      },
      {
        // Static segment, so it outranks the :courseAlias sibling — a series
        // and a course can safely share the /course namespace.
        path: 'path/:pathAlias',
        element: <GuidedCoursePathPage />,
      },
      {
        // Static segment too, so it outranks :courseAlias. Immersive: see
        // SharedLayout's IMMERSIVE_ROUTES — the forge keeps the navbar and
        // drops the sidebar, because the stage carries its own exit.
        path: 'forge',
        element: <CourseForgePage />,
      },
      {
        path: ':courseAlias',
        element: <GuidedCourseDetailPage />,
      },
      {
        path: ':courseAlias/intro/:nodeId',
        element: <GuidedCourseIntroPage />,
      },
      {
        path: ':courseAlias/read/:labelId',
        element: <GuidedCourseReadingPage />,
      },
      {
        path: ':courseAlias/play/:sessionId',
        element: <GuidedCoursePlayPage />,
      },
      {
        path: ':courseAlias/test/:sessionId',
        element: <GuidedCourseTestPage />,
      },
    ],
  },
  {
    // Main page: category cards. Stays inside the normal sidebar layout.
    path: '/coding-practice',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <CodingPractice />,
        index: true,
      },
    ],
  },
  {
    // Immersive "zone": full-screen map, no SharedLayout (sidebar/topbar gone).
    path: '/coding-practice/category/:slug',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <CodingCategoryZone />
      </AuthorizedWrapper>
    ),
  },
  {
    // Coding screen, also full-screen so the zone feels continuous.
    path: '/coding-practice/:slug',
    element: (
      <AuthorizedWrapper
        userTypes={[
          UserRole.Admin,
          UserRole.Applicant,
          UserRole.ContentManager,
        ]}
      >
        <CodingProblem />
      </AuthorizedWrapper>
    ),
  },
  {
    path: '/skill-builder/multiplayer',
    element: (
      <AuthorizedWrapper userTypes={MULTIPLAYER_USER_TYPES}>
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <MultiplayerPractice />,
        index: true,
      },
      {
        element: <MultiplayerRoomRoute />,
        path: ':roomId',
      },
      {
        element: <SkillBuilderMultiPlay />,
        path: ':roomId/play',
      },
    ],
  },
  {
    path: '/support',
    element: <SharedLayout />,
    children: [
      {
        element: <Support />,
        index: true,
      },
    ],
  },
  {
    path: '/support/report-bug',
    element: <SharedLayout />,
    children: [
      {
        element: <ReportBug />,
        index: true,
      },
    ],
  },
  {
    path: '/support/feature-request',
    element: <SharedLayout />,
    children: [
      {
        element: <FeatureRequest />,
        index: true,
      },
    ],
  },
  {
    path: '/support/feedback',
    element: <SharedLayout />,
    children: [
      {
        element: <Feedback />,
        index: true,
      },
    ],
  },
  {
    path: '/support/my-reports',
    element: <SharedLayout />,
    children: [
      {
        element: <MyReports />,
        index: true,
      },
      {
        path: ':feedbackId',
        element: <MyReportDetail />,
      },
    ],
  },
  {
    path: '/skill-test',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Admin, UserRole.Applicant]}>
        <SharedLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <SkillTest />,
        index: true,
      },
      {
        path: ':testId/play',
        element: <SkillTestPlay />,
      },
      {
        path: ':testId/result',
        element: <SkillTestResult />,
      },
    ],
  },
  {
    path: '/store',
    element: <CandidateLayout />,
    children: [
      {
        element: <StoreHome />,
        index: true,
      },
      {
        // Entered only from the mobile app's web-checkout fallback
        // (/login?token=...&redirectTo=/store/checkout). No web nav points here.
        element: <StoreCheckout />,
        path: 'checkout',
      },
      {
        element: <SpotlightSuccess />,
        path: 'spotlight-success/:transactionId',
      },
      {
        element: <PremiumSuccess />,
        path: 'premium-success',
      },
      {
        element: <OrdersHistory />,
        path: 'orders-history',
      },
    ],
  },
  {
    path: '/leaderboard',
    element: <CandidateLayout />,
    children: [
      {
        element: <LeaderboardPage />,
        index: true,
      },
      {
        element: <SkillSelectorMobilePage />,
        path: 'skill',
      },
    ],
  },
  {
    path: '/applicant-dashboard',
    element: <CandidateLayout />,
    children: [
      {
        element: <ApplicantDashboard />,
        index: true,
      },
    ],
  },
  {
    // The student view: a Learner's classes, with a sidebar of its own. The
    // profile menu switches here and back.
    path: '/classes',
    element: <StudentLayout />,
    children: [
      { element: <StudentClasses />, index: true },
      { element: <StudentTodo />, path: 'todo' },
      { element: <StudentCourses />, path: 'courses' },
      { element: <StudentCourse />, path: 'courses/:courseId' },
      {
        element: <StudentLesson />,
        path: 'courses/:courseId/subtopics/:subtopicId',
      },
      { element: <CandidateSettings />, path: 'settings' },
      { element: <StudentClass />, path: ':classId' },
      { element: <QuizAttempt />, path: ':classId/quizzes/:quizId' },
      { element: <QuizMarks />, path: ':classId/marks/:quizId' },
    ],
  },
  {
    path: '/career-guidance',
    element: <CandidateLayout />,
    children: [
      {
        element: <CareerGuidancePage />,
        index: true,
      },
    ],
  },
  {
    path: 'admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <AdminHomeRedirect />,
      },
      {
        path: 'dashboard',
        element: <AdminDashboard />,
      },
      {
        path: 'support',
        element: <AdminChat />,
        index: true,
      },
      {
        path: 'review-orgs',
        element: <ReviewOrg />,
        index: true,
      },
      {
        path: 'review-jobs',
        children: [
          {
            element: <ReviewJob />,
            index: true,
          },
          {
            element: <MatchingProfiles />,
            path: ':jobId/matching-profiles',
          },
        ],
      },
      {
        path: 'background-verifications',
        element: <BackgroundVerificationsAdmin />,
        index: true,
      },
      {
        path: 'managed-hiring-requests',
        children: [
          {
            element: <ManagedHiringAdmin />,
            index: true,
          },
          {
            element: <ManagedHiringRequestDetail />,
            path: ':requestId',
          },
        ],
      },
      {
        path: 'external-jobs',
        element: <ExternalJobsAdmin />,
        index: true,
      },
      {
        path: 'turbohire-intel',
        element: <TurbohireIntel />,
      },
      {
        path: 'chrome-extension',
        element: (
          <StatePreservingNavigate
            to="/admin/statistics/chrome-extension"
            keepSearch
          />
        ),
      },
      {
        path: 'job-email-settings',
        element: <JobEmailSettings />,
        index: true,
      },
      {
        path: 'user-management',
        element: <UserManagement />,
        index: true,
      },
      {
        path: 'outreach',
        element: <OutreachAdmin />,
      },
      {
        path: 'email-templates',
        children: [
          { element: <EmailTemplatesAdmin />, index: true },
          { element: <EmailTypeDetail />, path: ':typeId' },
        ],
      },
      {
        path: 'global-vars',
        element: <GlobalVarsAdmin />,
        index: true,
      },
      {
        path: 'credit-pricing',
        element: <CreditPricingAdmin />,
      },
      {
        path: 'career-guidance',
        element: <CareerGuidanceAdmin />,
        index: true,
      },
      {
        path: 'interview-recordings',
        element: <InterviewRecordingsAdmin />,
        index: true,
      },
      {
        path: 'app-version',
        element: <AppVersionAdmin />,
        index: true,
      },
      {
        path: 'api-token',
        element: <AdminToken />,
      },
      {
        path: 'resume-templates',
        element: <ResumeAdminLayout />,
        children: [
          { element: <ResumeAdminHomepage />, index: true },
          {
            element: <CreateResumeTemplatePage key="create" />,
            path: 'create',
          },
          {
            element: <CreateResumeTemplatePage key="update" />,
            path: 'update',
          },
        ],
      },
      {
        path: 'competition',
        children: [
          {
            element: (
              <CompetitionListAdmin
                createNavigateTo={'/admin/user-competition/create'}
              />
            ),
            index: true,
          },
          {
            element: (
              <StatePreservingNavigate to="/admin/user-competition/create" />
            ),
            path: 'create',
          },
          {
            element: <CreateEditCompetition />,
            path: ':competitionAlias/edit',
          },
          {
            element: <CompetitionScoreAdmin />,
            path: ':competitionAlias/score',
          },
        ],
      },
      {
        path: 'statistics',
        element: <StatisticsLayout />,
        children: [
          { element: <StatisticsAdmin />, index: true },
          { element: <AskAbekusAdmin />, path: 'ask-abekus' },
          { element: <CourseStatsAdmin />, path: 'courses' },
          { element: <ChromeExtensionAdmin />, path: 'chrome-extension' },
          { element: <ReviewStatsAdmin />, path: 'reviews' },
          { element: <SkillStatistics />, path: 'skills' },
          {
            element: <StatisticsAdmin page="creditActionType" />,
            path: 'credits',
          },
          { element: <StatisticsAdmin page="email" />, path: 'emails' },
          {
            element: <StatisticsAdmin page="signup" />,
            path: 'signup-sources',
          },
          {
            element: <StatisticsAdmin page="signupPage" />,
            path: 'signup-pages',
          },
          {
            element: <StatisticsAdmin page="algoLogs" />,
            path: 'algo-logs',
          },
          {
            element: <StatisticsAdmin page="aiUsage" />,
            path: 'ai-usage',
          },
          {
            element: <StatisticsAdmin page="premiumSubscriptions" />,
            path: 'premium-subscriptions',
          },
        ],
      },
      {
        path: 'bulk-email',
        element: <BulkEmail />,
      },
      {
        path: 'experiments',
        element: <ExperimentsAdmin />,
      },
      {
        path: 'ai-models',
        element: <AiModelsAdmin />,
      },
      {
        path: 'send-whatsapp',
        element: <WhatsappNotifiactionAdmin />,
      },
      {
        path: 'send-mobile-notification',
        element: <MobileAppNotificationAdmin />,
      },
      {
        path: 'review-questions',
        element: <ReviewQuestionsAdmin />,
      },
      {
        path: 'reported-bugs',
        element: <BugsReportedAdmin />,
      },
      {
        path: 'level',
        children: [
          { element: <LevelAdmin />, index: true },
          { element: <CreateEditLevel />, path: 'create' },
          { element: <CreateEditLevel />, path: ':levelId/edit' },
        ],
      },
      // The platform-wide XP ladder, kept apart from 'level' above — that one
      // is the per-skill score ladder and the two are unrelated.
      {
        path: 'platform-level',
        children: [
          { element: <UserLevelAdmin />, index: true },
          { element: <CreateEditUserLevel />, path: 'create' },
          { element: <CreateEditUserLevel />, path: ':levelId/edit' },
        ],
      },
      {
        path: 'daily-mission',
        children: [
          { element: <DailyMissionAdmin />, index: true },
          { element: <CreateEditDailyMission />, path: 'create' },
          { element: <CreateEditDailyMission />, path: ':missionId/edit' },
        ],
      },
      {
        path: 'reward-promotion',
        children: [
          { element: <RewardPromotionAdmin />, index: true },
          { element: <CreateEditRewardPromotion />, path: 'create' },
          {
            element: <CreateEditRewardPromotion />,
            path: ':promotionId/edit',
          },
        ],
      },
      {
        path: 'badge',
        children: [
          { element: <BadgeAdmin />, index: true },
          { element: <CreateEditBadge />, path: 'create' },
          { element: <CreateEditBadge />, path: ':badgeId/edit' },
        ],
      },
      {
        path: 'coding-practice',
        children: [
          { element: <CodingPracticeAdmin />, index: true },
          { element: <CodingPracticeCategoryAdmin />, path: ':slug' },
        ],
      },
      {
        path: 'dashboard-banner',
        children: [
          { element: <DashboardBannerAdmin />, index: true },
          { element: <CreateEditDashboardBanner />, path: 'create' },
          { element: <CreateEditDashboardBanner />, path: ':bannerId/edit' },
        ],
      },
      {
        path: 'coupon',
        children: [
          { element: <CouponAdmin />, index: true },
          { element: <CreateEditCoupon />, path: 'create' },
          { element: <CreateEditCoupon />, path: ':couponId/edit' },
        ],
      },
      {
        path: 'mocktest',
        children: [
          { element: <MocktestAdmin />, index: true },
          { element: <MocktestForm />, path: 'create' },
          { element: <MocktestForm />, path: 'edit/:mocktestId' },
        ],
      },
      {
        path: 'store',
        children: [
          {
            element: <OrdersAdmin />,
            index: true,
          },
          {
            path: 'items',
            children: [
              { element: <StoreAdmin />, index: true },
              { element: <StoreItemsByType />, path: 'type/:itemType' },
              { element: <ItemVariantsAdmin />, path: ':itemId/variants' },
            ],
          },
          // legacy alias — keep old /admin/store/orders bookmarks working
          {
            element: <OrdersAdmin />,
            path: 'orders',
          },
        ],
      },
      {
        path: 'potential-recruiters',
        children: [{ element: <PotentialRecruiterPage />, index: true }],
      },
      {
        path: 'data-management',
        children: [
          { element: <DataManagment />, index: true },
          {
            element: <Specialization />,
            path: 'specialization',
          },
          {
            element: <Specialization />,
            path: 'specialization/:degreeId',
          },
        ],
      },
      {
        path: 'campus-ambassador',
        children: [
          { element: <CampusAmbassadorAdmin />, index: true },
          { path: 'create', element: <CreateCACohort /> },
          { path: ':cohortId/edit', element: <CreateCACohort /> },
          { path: ':cohortId', element: <CampusAmbassadorCohortDetail /> },
          {
            path: ':cohortId/leaderboard',
            element: <CampusAmbassadorLeaderboard />,
          },
        ],
      },
      { path: 'potential-applicants', element: <PotentialApplicants /> },
      { path: 'subscriptions', element: <Subscriptions /> },
      {
        path: 'user-competition',
        children: [
          {
            element: (
              <CompetitionListAdmin
                createNavigateTo={'/admin/user-competition/create'}
              />
            ),
            index: true,
          },
          { element: <CreateEditCompetition />, path: 'create' },
          {
            element: <CreateEditCompetition />,
            path: ':competitionAlias/edit',
          },
          {
            element: <CompetitionDetails />,
            path: ':competitionAlias',
          },
          {
            element: <ViewCandidates />,
            path: 'candidates/:competitionId',
          },
          {
            element: <AnswersByCandidates />,
            path: 'candidates/:competitionId/view-details/:userId',
          },
        ],
      },
      {
        path: 'chat-logs',
        element: <ChatLogs />,
      },
      {
        path: 'activity-logs',
        children: [
          { element: <ActivityAdmin />, index: true },
          { element: <ActivityAdmin />, path: ':userId' },
        ],
      },
      {
        path: 'audit-logs',
        element: <AuditLogAdmin />,
      },
      {
        path: 'gems-activity',
        element: <GemsActivity />,
      },
      {
        path: 'referral-summary',
        element: <ReferralSummary />,
      },
      {
        path: 'referral-milestones',
        element: <ReferralMilestonesAdmin />,
      },
      {
        path: 'faculty',
        element: <FacultyAdmin />,
      },
      {
        path: 'multiplayer-personas',
        element: <MultiplayerPersonasAdmin />,
      },
      {
        path: 'skill-relevance',
        element: <SkillRelevanceAdmin />,
      },
      {
        path: 'skill/statistics',
        element: <StatePreservingNavigate to="/admin/statistics/skills" />,
      },
      {
        path: 'skills/:skillType/:parentId?',
        element: <SkillManagementAdmin />,
      },
      {
        path: 'skill-todos',
        element: <SkillTodosAdmin />,
      },
      {
        path: 'courses',
        element: <CoursesAdmin />,
      },
      {
        path: 'course-feedback',
        element: <CourseFeedbackAdmin />,
      },
      {
        path: 'skills/questions/:skillId',
        element: <Questions />,
      },
      {
        path: 'skill-content/:skillId',
        element: <SkillContentFormAdmin />,
      },
      {
        path: 'competition-content/:competitionId',
        element: <CompetitionContentAdmin />,
      },
      {
        path: 'skill-series',
        element: <SkillSeriesAdmin />,
      },
      {
        path: 'competition/:competitionId/questions',
        element: <JobChallengeQuestions />,
      },
    ],
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '404',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/evaluation-assessment/:jobAlias',
    element: (
      <AuthorizedWrapper userTypes={[UserRole.Admin, UserRole.Employer]}>
        <EmployerLayout />
      </AuthorizedWrapper>
    ),
    children: [
      {
        element: <EvaluationAssessmentCreate />,
        index: true,
      },
    ],
  },
];

export default getRoutes;
